import { IAppointment, IChatConversation } from 'src/types';
import {
  IReduxAction,
  QUOTE_SET_APPOINTMENT,
  QUOTE_SET_ZIP,
  ESTIMATE_ITEM_STATUS,
  QUOTE_SET_CHAT,
  QUOTE_SET_DIAGNOSIS_PRICE,
} from '../types';

export const setZip = (zip: string): IReduxAction => ({
  type: QUOTE_SET_ZIP,
  payload: { zip },
});

export const setAppointment = (
  appointment: IAppointment | null
): IReduxAction => ({
  type: QUOTE_SET_APPOINTMENT,
  payload: appointment,
});

export const updateAppointment = (
  appointment: IAppointment | null
): IReduxAction => ({
  type: QUOTE_SET_APPOINTMENT,
  payload: appointment,
});

export const estimateItemStatus = (
  s: string,
  status: string
): IReduxAction => ({
  type: ESTIMATE_ITEM_STATUS,
  payload: { s, status },
});

export const setChat = (chat: IChatConversation): IReduxAction => ({
  type: QUOTE_SET_CHAT,
  payload: chat,
});

export const setDiagnosisPrice = (price: number, zip_code: string): IReduxAction => ({
  type: QUOTE_SET_DIAGNOSIS_PRICE,
  payload: { price, zip_code },
});
